import React from 'react';
import TextField from '@mui/material/TextField';
import { formatShortcutLabel, shortcutFromKeyboardEvent } from './viewerKeyboardShortcuts';

export default function ShortcutCaptureField({ label, value, onChange, size = 'small', ...props }) {
  const capture = (event) => {
    if (event.key === 'Tab') return;
    if (event.key === 'Backspace' || event.key === 'Delete') {
      event.preventDefault();
      event.stopPropagation();
      onChange('');
      return;
    }
    const shortcut = shortcutFromKeyboardEvent(event);
    if (!shortcut) return;
    event.preventDefault();
    event.stopPropagation();
    onChange(shortcut);
  };

  return (
    <TextField
      {...props}
      size={size}
      label={label}
      value={String(value || '').includes('+') ? formatShortcutLabel(value) : String(value || '')}
      onKeyDown={capture}
      inputProps={{
        ...(props.inputProps || {}),
        readOnly: true,
        'aria-label': props.inputProps?.['aria-label'] || `${label} shortcut key`,
      }}
      helperText={props.helperText || 'Press a letter, Shift+letter, or Alt+letter. Backspace clears.'}
    />
  );
}
